export function assertEnabledAPI(value, message) {
    if (process.env.NODE_ENV !== 'production' && value == null) {
        throw new Error(message);
    }
}
//# sourceMappingURL=assertEnabledAPI.js.map